import CreatePost from "./createPost";
import { useNavigate } from "react-router-dom";

export default function CreatePostScreen() {
  const navigate = useNavigate();

  return (
    <CreatePost
      onBack={() => navigate(-1)}
      onContinue={() => navigate("/viewPost")}
    />
  );
}
